const getTemplate = type => {
    if (type.indexOf('sm') !== -1) {
        return `<div class="notification notification--${type} notification--sm noty_message">
                    <div class="notification__left">
                        <div class="notification__icon"></div>
                    </div>
                    <p class="notification__text noty_text"></p>
                    <div class="notification__right noty_buttons">
                    </div>
                </div>`;
    } else {
        return `<div class="notification notification--${type} noty_message">
                    <div class="notification__title js-notification-title"></div>
                    <p class="notification__text noty_text"></p>
                    <div class="notification__controls noty_buttons"></div>
                </div>`;
    }
};

$.noty.defaults = {
    layout: 'topRight',
    theme: 'relax',
    type: 'info',
    text: '',
    title: '',
    dismissQueue: true,
    template: getTemplate('error'),
    animation: {
        open: { opacity: 'show' },
        close: { opacity: 'hide' },
        easing: 'swing',
        speed: 500
    },
    timeout: 5000,
    force: false,
    modal: false,
    maxVisible: 10,
    killer: false,
    closeWith: ['button'],
    callback: {
        onShow: function() {
            const bar = this.$bar[0];
            bar.style.border = '0';
            bar.style.boxShadow = '0 12px 36px rgba(0, 0, 0, 0.12)';

            if (this.options.type.indexOf('sm') === -1) {
                const titleEl = bar.getElementsByClassName(
                    'js-notification-title'
                )[0];
                const title = this.options.title;

                if (title.length > 0) {
                    titleEl.innerHTML = title;
                } else {
                    titleEl.parentNode.removeChild(titleEl);
                }
            }
        },
        afterShow: function() {},
        onClose: function() {},
        afterClose: function() {},
        onCloseClick: function() {}
    },
    buttons: [],
};

global.showNotyfications = function(messageN, optionsN) {
    let notyOpt = {};
    if (typeof optionsN !== 'undefined') {
        notyOpt = Object.assign(optionsN);
        if (optionsN.type == undefined) {
            notyOpt.type = 'error';
        }
        if (optionsN.template == undefined) {
            optionsN.template = getTemplate(notyOpt.type);
        }
        if (optionsN.layout == undefined) {
            notyOpt.layout = 'topRight';
        }
    }
    notyOpt.text = messageN;
    noty(notyOpt);
};

$('.js-noty').on('click', function(e) {
    e.preventDefault();
    let $this = $(this);
    let buttons = [];

    $this.data('message-btn-ok')
        ? buttons.push({
              addClass: 'notification__btn',
              text: $this.data('message-btn-ok'),
              onClick: function($noty) {
                  $noty.close();
              }
          })
        : null;

    $this.data('message-btn-cancel')
        ? buttons.push({
              addClass: 'notification__btn notification__btn--outline',
              text: $this.data('message-btn-cancel'),
              onClick: function($noty) {
                  $noty.close();
              }
          })
        : null;

    typeof $this.data('message-btn-close') !== 'undefined'
        ? buttons.push({
              addClass: 'notification__close',
              text: '',
              onClick: function($noty) {
                  $noty.close();
              }
          })
        : null;

    noty({
        text: $this.data('message'),
        type: $this.data('type'),
        layout: $this.data('layout'),
        title: $this.data('title'),
        buttons,
        template: getTemplate($this.data('type')),
    });
    return false;
});



// WEBPACK FOOTER //
// ./frontend/components/notifications/notifications.js